<template>
    <div>
        Correspondance

        <edit_tabulator :style="'max-width: ' + (size - 100) + 'px'" @update="update_data" ref="reference_tabulator" />

        <b-card>
            <template #header>
                <h3 class="mb-0">Colonnes clés</h3>
            </template>
            <b-card-body style="padding:0px">
                <div v-for="(obj, idx) in key_columns" :key="idx" >
                    <b-container style="margin: 0; padding: 0; max-width: none;">
                        <b-row :style="'border-radius: 5px; margin: 3px; padding: 5px;'">
                            <b-col>
                                <b-form-input @change="(obj.key_reference == '' && columns_reference_data.includes(obj.key)) ? obj.key_reference = obj.key : '' " v-model="obj.key" :list="'upstream-columns' + id" placeholder="Colonne du fichier d'entrée"></b-form-input>
                                <b-form-datalist :id="'upstream-columns' + id" :options="columns_data"></b-form-datalist>
                            </b-col>
                            <b-col>
                                <b-form-input @change="(obj.key == '' && columns_reference_data.includes(obj.key_reference)) ? obj.key = obj.key_reference : '' " v-model="obj.key_reference" :list="'uploaded-columns' + id" placeholder="Colonne du fichier de corespondance"></b-form-input>
                                <b-form-datalist :id="'uploaded-columns' + id" :options="columns_reference_data"></b-form-datalist>
                            </b-col>
                            <b-col cols="auto">
                                <b-button variant="primary" @click="addKeyColumn">+</b-button>&nbsp;
                                <b-button variant="danger" @click="removeKeyColumn(idx)" :disabled="key_columns.length === 1">-</b-button>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
            </b-card-body>
        </b-card>

        <b-card>
            <template #header>
                <h3 class="mb-0">Colonnes à ajouter</h3>
            </template>
            <b-card-body style="padding:0px">
                <div v-for="(obj, idx) in values_column" :key="idx" @click="toggleColumnSelection(idx)" :style="'border-radius: 5px; margin: 3px; padding: 5px;' + (obj.selected ? 'background-color: #76e376' : 'background-color: inherit')">
                    <b-container style="margin: 0; padding: 0; max-width: none;">
                        <b-row>
                            <b-col>
                                {{ obj.key }}
                            </b-col>
                            <b-col>
                                <b-form-input v-model="obj.value" @click.stop></b-form-input>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

	import edit_tabulator from "../edit_tabulator.vue";

    var clone = require("clone");
    
    export default {
        name: "correspondance",
		components: {
            edit_tabulator
		},
		props: {
            treatment_params: {
                default: false
            },
            files: {
                default: () => []
            },
			data: {
				default: () => [],
            },
			client: {
				default: null
            },
            size: {
                default: 1000
            }
        },
        watch: 
        {
            data: {
                deep: true,
                immediate: true,
                handler()
                {
                    if (this.data.length != 0)
                    {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            },
            files: {
                deep: true,
                immediate: true,
                handler()
                {
                    //console.log(this.files);

                    if (this.files.length > 0)
                    {
                        var self = this;
                        var reader = new FileReader();

                        reader.onload = (function (theFile) {
                            return function (e) {
                                if (e.target.result)
                                {
                                    var data = self.$papa.parse(e.target.result, { header: true });
                                    if (data.data && data.data.length > 0)
                                    {
                                        self.columns_data = Object.keys(data.data[0]);
                                    }
                                }
                            };
                        })(this.files[0].file ? this.files[0].file : this.files[0]);

                        reader.readAsText(this.files[0].file ? this.files[0].file : this.files[0]);
                    }
                }
            }
        },
        computed: {
            
        },
		data() {
			return {
                id: uniqueId(""),

                columns_data: [],
                columns_reference_data: [],

                values_column: [],
                key_columns: [{key: "", key_reference: ""}]
			};
        },
        methods: {
			update_data()
			{
				console.log("import_file")
                var data = this.$refs.reference_tabulator.get_data();
                this.columns_reference_data = Object.keys(data[0])

                var values_column_obj = {};
                for (var i = 0; i < this.values_column.length; i++)
                {
                    values_column_obj[this.values_column[i].key] = this.values_column[i];
                }

                var values_column = [];
                for (var i = 0; i < this.columns_reference_data.length; i++)
                {
                    if (values_column_obj[this.columns_reference_data[i]])
                        values_column.push(values_column_obj[this.columns_reference_data[i]]);
                    else
                    {
                        values_column.push({
                            key: this.columns_reference_data[i],
                            value: this.columns_reference_data[i],
                            selected: false
                        })
                    }
                }
                this.values_column = values_column;
			},
            get_data()
            {
                return this.save()
            },
            save()
            {
                return {
                    reference_tabulator: this.$refs.reference_tabulator.get_data(),
                    columns_data: this.columns_data,
                    columns_reference_data: this.columns_reference_data,
                    key_columns: this.key_columns,
                    values_column: this.values_column
                }
            },
            async load(data)
            {
                console.log("load " + this.id)
                
                if (!data)
                {
                    return;
                }

                console.log(data)

                if (data.reference_tabulator)
                    this.$refs.reference_tabulator.set_data(data.reference_tabulator);

                await this.$nextTick();
                
                if (data.columns_data)
                    this.columns_data = data.columns_data;
                if (data.columns_reference_data)
                    this.columns_reference_data = data.columns_reference_data;
                if (data.key_columns)
                    this.key_columns = data.key_columns;
                if (data.values_column)
                    this.values_column = data.values_column;
            },
            addKeyColumn()
            {
                this.key_columns.push({key: "", key_reference: ""});
            },
            removeKeyColumn(idx)
            {
                this.key_columns.splice(idx, 1);
            },
            toggleColumnSelection(idx) {
                this.$set(this.values_column[idx], "selected", this.values_column[idx].selected ? false : true);
            },
        },
        async mounted()
        {			
        }
    }
</script>

<style scoped>
</style>